import './style.scss';

// ? [REVISIT] much boilerplate here is just to setup HMR ... :(
import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import { ApolloProvider } from '@apollo/client';

import { isLocal, isProduction } from '../../utils/environment';
import App from './components/PlpPageContainer';
import ErrorBoundary, { ExplicitDeadEnd } from '../../utils/react/ErrorBoundary';
import { createApolloClientWithCache } from '../_shared/apolloClientUtils';
import { heapTrack, isInternetExplorer } from '../../utils/helpers';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PlpProvider from './PLPContext';

const targetElement = document.getElementById('REACT-PLP');
// ? [REVISIT] way to much duplication w/ PDP
const loadFallback = () => {
  var fallbackContentUrl = `//${window.location.host}${window.location.pathname}?view=fallback`;
  var main = document.getElementById('MainContent') || document.getElementsByTagName('main')[0] || document.body;
  fetch(fallbackContentUrl)
    .then((response) => response.text())
    .then((altContent) => {
      main.innerHTML = altContent;
    })
    .catch((err) => {
      // ? [REVISIT] alert causes a lot of grief on the App
      // alert('Sorry, there was an error. Please try a different collection.');
    });
};
const onError = (err: Error) => {
  console.error('PLP crash: ', { err });
  heapTrack('plp crash', { url: window.location.pathname, err: (err && err.message) || undefined });
  if (isProduction) loadFallback();
};

const client = createApolloClientWithCache();

const render = (Component: () => JSX.Element | null) => {
  return ReactDOM.render(
    <StrictMode>
      <ErrorBoundary
        className="centered-message"
        key={(!isLocal || new Date()).toString()}
        onError={onError}
        errorRender={isProduction ? () => null : undefined}
      >
        <PlpProvider>
          <ApolloProvider client={client}>
            <Router>
              <Routes>
                {/* Other solves/ideas:
                - would be to use `/:intlprefix?/` but we're on a weird version of React Router; upgrading library versions prior to 2 big releases ~> too risky
                - using `window.Shopify.routes.root` as part dynamically constructed has 1 minor benifit, if someone enters invalid (locale) prefix combination & Shopify doesn't recognize that argument --> that would account for that, but not enough time to test that idea out
              */}
                <Route path="/:shopifyRoot/collections/:id/:colorway" element={<Component />} />
                <Route path="/:shopifyRoot/collections/:id/*" element={<Component />} />
                <Route path="/collections/:id/:colorway" element={<Component />} />
                <Route path="/collections/:id/*" element={<Component />} />
                <Route path="*" element={<ExplicitDeadEnd />} />
              </Routes>
            </Router>
          </ApolloProvider>
        </PlpProvider>
      </ErrorBoundary>
    </StrictMode>,
    targetElement
  );
};

const renderPlpPage = () => {
  if (isInternetExplorer) {
    loadFallback();
  } else {
    render(App);
  }
};

export { renderPlpPage };

// HMR
if (process.env.NODE_ENV === 'development' && module?.hot) {
  module.hot.accept();
}
